import React from "react";
import {QuestionItem} from "../../common/webapicall";
import QuestionnaireAutoFillRandomizePanel from "../questionnaire-autofill/questionnaire.autofill.randomize.panel";
import QuestionnaireAutoFillDictatePanel from "../questionnaire-autofill/questionnaire.autofill.dictate.panel";

interface QuestionnaireAutofillPanelProps {
	questions: QuestionItem[];
	onSubmit: () => void;
}

const QuestionnaireAutofillPanel: React.FC<QuestionnaireAutofillPanelProps> = ({questions, onSubmit}: QuestionnaireAutofillPanelProps) => {
	return (
		<div className="debug-panel">
			<QuestionnaireAutoFillRandomizePanel questionList={questions} onSubmit={onSubmit} />
			<div><QuestionnaireAutoFillDictatePanel questionList={questions} onSubmit={onSubmit} /></div>
		</div>
	);
};

export default QuestionnaireAutofillPanel;
